import { render, staticRenderFns } from "./DerbyRaceLink.vue?vue&type=template&id=36665ab4&"
import script from "./DerbyRaceLink.vue?vue&type=script&lang=js&"
export * from "./DerbyRaceLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports